export default __webpack_public_path__ + "static/media/mode-30.552e28f8.svg";